// Central brand + business data for HATTORY KONVEKSI
export const BRAND = {
  name: "HATTORY KONVEKSI",
  short: "HATTORY",
  tagline: "Profesional • Cepat • Berkualitas",
  phone: "0857-1312-8864",
  waNumber: "6281578205036",
  email: "hattorykonveksi@gmail.com",
  address:
    "Desa Kendung, Kecamatan Kwadungan, Kabupaten Ngawi, Jawa Timur, Indonesia",
  website: "www.hattorykonveksi.com",
  logo: "https://customer-assets.emergentagent.com/job_custom-production-2/artifacts/z95s2ftf_logo%20hattory%20konveksi.png",
  socials: {
    instagram: "https://instagram.com/hattorykonveksi",
    tiktok: "https://tiktok.com/@hattorykonveksi",
    facebook: "https://facebook.com/hattorykonveksi",
    instagramHandle: "@hattorykonveksi",
    tiktokHandle: "@hattorykonveksi",
    facebookHandle: "HATTORY KONVEKSI",
  },
};

export const wa = (msg) =>
  `https://wa.me/${BRAND.waNumber}?text=${encodeURIComponent(msg)}`;

export const NAV = [
  { label: "Beranda", to: "/" },
  { label: "Produk", to: "/produk" },
  { label: "Proses", to: "/proses" },
  { label: "Tentang Kami", to: "/tentang" },
  { label: "Portofolio", to: "/portofolio" },
  { label: "Kontak", to: "/kontak" },
];

export const IMG = {
  heroSewing:
    "https://images.unsplash.com/photo-1745095034955-1019067b7ce4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxnYXJtZW50JTIwZmFjdG9yeSUyMHNld2luZyUyMG1hY2hpbmUlMjB3b3JrZXJ8ZW58MHx8fHwxNzg0MDYyNDE1fDA&ixlib=rb-4.1.0&q=85",
  factory:
    "https://images.unsplash.com/photo-1739117441029-9f2a8e59e8b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxnYXJtZW50JTIwZmFjdG9yeSUyMHNld2luZyUyMG1hY2hpbmUlMjB3b3JrZXJ8ZW58MHx8fHwxNzg0MDYyNDE1fDA&ixlib=rb-4.1.0&q=85",
  tshirt: "https://images.pexels.com/photos/12039633/pexels-photo-12039633.jpeg",
  textureWhite:
    "https://images.unsplash.com/photo-1593250816874-8edf4f732edb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxmYWJyaWMlMjB0ZXh0dXJlJTIwY2xvc2V1cCUyMHRleHRpbGV8ZW58MHx8fHwxNzg0MDYyNDE1fDA&ixlib=rb-4.1.0&q=85",
  textureGray:
    "https://images.unsplash.com/photo-1643313262988-cdc5f50c6019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxmYWJyaWMlMjB0ZXh0dXJlJTIwY2xvc2V1cCUyMHRleHRpbGV8ZW58MHx8fHwxNzg0MDYyNDE1fDA&ixlib=rb-4.1.0&q=85",
  jacket:
    "https://images.unsplash.com/photo-1584184924103-e310d9dc82fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxjdXN0b20lMjBqYWNrZXQlMjBhcHBhcmVsJTIwdGFpbG9yaW5nfGVufDB8fHx8MTc4NDA2MjQxNHww&ixlib=rb-4.1.0&q=85",
  tailoring:
    "https://images.unsplash.com/photo-1698812006400-b5a6c3fb0620?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxjdXN0b20lMjBqYWNrZXQlMjBhcHBhcmVsJTIwdGFpbG9yaW5nfGVufDB8fHx8MTc4NDA2MjQxNHww&ixlib=rb-4.1.0&q=85",
  jersey:
    "https://images.unsplash.com/photo-1649520937981-763d6a14de7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxzcG9ydHMlMjBqZXJzZXklMjBzaGlydCUyMGNsb3RoaW5nfGVufDB8fHx8MTc4NDA2MjQyNnww&ixlib=rb-4.1.0&q=85",
  design:
    "https://images.unsplash.com/photo-1561070791-2526d30994b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHdvcmtzcGFjZSUyMGFwcGFyZWwlMjBkZXNpZ258ZW58MHx8fHwxNzgxOTY5NjUxfDA&ixlib=rb-4.1.0&q=85",
};

export const HERO_SLIDES = [
  {
    title: "Konveksi Custom Berbasis Sistem",
    subtitle:
      "Setiap pesanan diproduksi lewat alur kerja dan quality control yang sama.",
    cta: "Konsultasi Gratis",
    waMsg:
      "Halo HATTORY KONVEKSI, saya ingin konsultasi gratis untuk kebutuhan konveksi custom.",
    image: IMG.heroSewing,
  },
  {
    title: "Kontrol Kualitas di Setiap Tahap",
    subtitle: "Kualitas dicek dari bahan baku sampai sebelum pengiriman.",
    cta: "Tanya Kualitas Produk",
    waMsg:
      "Halo HATTORY KONVEKSI, saya ingin bertanya soal kontrol kualitas produk Anda.",
    image: IMG.factory,
  },
  {
    title: "Mitra Produksi yang Bisa Diandalkan",
    subtitle:
      "Melayani perusahaan, sekolah, komunitas, hingga tim esports di seluruh Indonesia.",
    cta: "Mulai Konsultasi",
    waMsg:
      "Halo HATTORY KONVEKSI, saya ingin mulai konsultasi untuk produksi apparel.",
    image: IMG.jersey,
  },
];

export const FEATURES = [
  {
    title: "Sistem Terstruktur",
    desc: "Alur kerja yang jelas dari konsultasi sampai pengiriman, sehingga setiap order berjalan konsisten dan transparan.",
    image: IMG.design,
  },
  {
    title: "Kualitas Konsisten",
    desc: "Quality control berlapis di setiap tahap produksi menjaga hasil tetap sesuai standar HATTORY.",
    image: IMG.textureGray,
  },
  {
    title: "Pelayanan Responsif",
    desc: "Tim kami siap menjawab pertanyaan dan memandu proses order Anda dengan cepat via WhatsApp.",
    image: IMG.factory,
  },
];

export const VALUES_SHORT = ["Profesional", "Cepat", "Berkualitas", "Berbasis Data"];

export const MARQUEE = [
  "Profesional",
  "Berkualitas",
  "Cepat",
  "Custom Apparel",
  "Seragam",
  "Jaket",
  "Jersey",
  "Berbasis Sistem",
];

// Product categories grouped
export const PRODUCT_GROUPS = [
  {
    group: "Pakaian Jadi",
    items: [
      { name: "Kaos Custom", desc: "Kaos custom dengan bahan pilihan dan sablon rapi untuk berbagai kebutuhan.", image: IMG.tshirt },
      { name: "Polo Shirt", desc: "Polo shirt berkerah yang cocok untuk seragam kerja maupun komunitas.", image: IMG.textureWhite },
      { name: "Jersey Printing", desc: "Jersey printing full sublimasi untuk tim olahraga dan esports.", image: IMG.jersey },
      { name: "Kemeja", desc: "Kemeja custom dengan potongan rapi dan bahan nyaman dipakai.", image: IMG.tailoring },
      { name: "Jaket", desc: "Jaket custom untuk komunitas, perusahaan, hingga event.", image: IMG.jacket },
      { name: "Hoodie", desc: "Hoodie custom yang nyaman dengan bahan tebal berkualitas.", image: IMG.jacket },
    ],
  },
  {
    group: "Seragam",
    items: [
      { name: "Wearpack", desc: "Wearpack kerja yang kuat dan aman untuk kebutuhan industri.", image: IMG.tailoring },
      { name: "Rompi", desc: "Rompi custom untuk lapangan, event, maupun identitas tim.", image: IMG.jacket },
      { name: "Seragam Kantor", desc: "Seragam kantor profesional dengan identitas perusahaan Anda.", image: IMG.tailoring },
      { name: "Seragam Sekolah", desc: "Seragam sekolah rapi dan tahan lama untuk kegiatan harian.", image: IMG.textureWhite },
      { name: "Seragam Komunitas", desc: "Seragam komunitas dengan desain yang memperkuat kebersamaan.", image: IMG.jersey },
    ],
  },
  {
    group: "Teknik Produksi",
    items: [
      { name: "Bordir Komputer", desc: "Bordir komputer presisi untuk logo dan detail yang tajam.", image: IMG.design },
      { name: "Sablon Plastisol", desc: "Sablon plastisol dengan hasil pekat, tebal, dan awet.", image: IMG.textureGray },
      { name: "Sablon DTF", desc: "Sablon DTF fleksibel untuk desain penuh warna dan detail rumit.", image: IMG.design },
      { name: "Sublimasi", desc: "Teknik sublimasi untuk motif full print yang menyatu dengan bahan.", image: IMG.jersey },
    ],
  },
];

export const PRODUCT_PREVIEW = [
  { name: "Kaos Custom", image: IMG.tshirt },
  { name: "Jersey Printing", image: IMG.jersey },
  { name: "Jaket & Hoodie", image: IMG.jacket },
  { name: "Seragam Kantor", image: IMG.tailoring },
  { name: "Bordir Komputer", image: IMG.design },
  { name: "Sablon & Sublimasi", image: IMG.textureGray },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Konsultasi", icon: "MessageCircle", desc: "Diskusi kebutuhan, jumlah, dan target budget via WhatsApp." },
  { n: "02", title: "Desain", icon: "PenTool", desc: "Pembuatan mock-up desain untuk di-ACC customer." },
  { n: "03", title: "DP", icon: "Wallet", desc: "Konfirmasi order dengan pembayaran DP." },
  { n: "04", title: "Produksi", icon: "Scissors", desc: "Cutting, printing/bordir, jahit, dan finishing." },
  { n: "05", title: "Quality Control", icon: "ShieldCheck", desc: "Diperiksa di setiap tahap, bukan cuma sekali di akhir." },
  { n: "06", title: "Pengiriman", icon: "Truck", desc: "Dikirim ke seluruh Indonesia." },
];

export const PROCESS_HIGHLIGHTS = [
  "Sistem Terintegrasi",
  "Produksi Terjadwal",
  "Quality Control Berlapis",
  "Pengiriman Tepat Waktu",
];

export const MISSION = [
  "Menghadirkan produk berkualitas tinggi secara konsisten.",
  "Memberikan pelayanan yang cepat dan profesional.",
  "Membangun jaringan showroom di berbagai kota.",
  "Menjalankan sistem bisnis yang berkelanjutan.",
  "Menjadikan teknologi ERP, CRM, SOP, dan KPI sebagai fondasi operasional.",
];

export const VALUES_FULL = [
  "Profesional", "Cepat", "Berkualitas", "Jujur", "Bertanggung Jawab",
  "Disiplin", "Inovatif", "Berorientasi Pelanggan", "Berbasis Data",
];

export const TARGET_MARKET = [
  "Perusahaan", "Instansi Pemerintah", "Sekolah", "Universitas", "Komunitas",
  "Organisasi", "UMKM", "Event Organizer", "Brand Fashion", "Tim Olahraga",
  "Esports", "BUMN", "Koperasi",
];

export const GUARANTEES = [
  { title: "Revisi Desain", icon: "PenTool", desc: "Revisi desain sebelum produksi dimulai, sampai Anda yakin dengan hasilnya." },
  { title: "Transparansi Proses", icon: "Eye", desc: "Progres order bisa dipantau, bukan tebak-tebakan." },
  { title: "Komunikasi Responsif", icon: "MessageCircle", desc: "Tim kami siap menjawab pertanyaan Anda dengan cepat via WhatsApp." },
  { title: "Quality Control Bertahap", icon: "ShieldCheck", desc: "Diperiksa di setiap fase produksi sebelum lanjut ke tahap berikutnya." },
];
